import repository from '@/repositories/repository'
import urlUtil from '@/utils/url'

export default baseUrl => {
    baseUrl = `${baseUrl}/fila-atendimento`

    return {
        create(filaId = null) {
            if (filaId) {
                return repository.get(`${baseUrl}/create/${filaId}`)
            } else {
                return repository.get(`${baseUrl}/create`)
            }
        },
        createEncaminhamento(filaId) {
            return repository.get(`${baseUrl}/create-encaminhamento/${filaId}`)
        },
        store(params) {
            return repository.post(`${baseUrl}`, params)
        },
        edit(id) {
            return repository.get(`${baseUrl}/${id}/edit`)
        },
        update(id, params) {
            return repository.put(`${baseUrl}/${id}`, params)
        },
        list(queryParms) {
            return repository.get(`${baseUrl}/list?${urlUtil.serialize(queryParms)}`)
        },
        listEncaminhamento(queryParms) {
            return repository.get(`${baseUrl}/list-encaminhamento?${urlUtil.serialize(queryParms)}`)
        },
        paciente: {
            autocomplete(queryParms = {}) {
                return repository.get(`${baseUrl}/autocomplete-paciente?${urlUtil.serialize(queryParms)}`)
            },
        },
        forward(id, params) {
            return repository.put(`${baseUrl}/${id}/forward`, params)
        },
        evade(id, params) {
            return repository.put(`${baseUrl}/${id}/evade`, params)
        },
        sendBack(id) {
            return repository.put(`${baseUrl}/${id}/send-back`)
        },
    }
}